import React, { Suspense } from "react";

// Lazy-load the plugin via its package name; npm workspaces will link EIMP-CHAT-PLUGIN
// The plugin exposes a named export `ChatWidget`, so map it to a `default` for React.lazy
const ChatWidget = React.lazy(() =>
  import("eimp-chat-plugin").then(mod => ({
    default: mod.default || mod.ChatWidget
  }))
);

export default function AssistantChat(props) {
  return (
    <Suspense fallback={null}>
      <ChatWidget {...props} />
    </Suspense>
  );
}
